export const coolingMaintenanceStateTypes = {
    ON: 'on',
    OFF: 'off',
    UNDEFINED: 'undefined',
};

export default coolingMaintenanceStateTypes;
